import script from "./PublicDisenosView.vue?vue&type=script&setup=true&lang=js"
export * from "./PublicDisenosView.vue?vue&type=script&setup=true&lang=js"

import "./PublicDisenosView.vue?vue&type=style&index=0&id=f4fe601c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f4fe601c"]])

export default __exports__